// View toggle — switches between list and grid layout for hosted sites

import { LayoutGrid, List } from 'lucide-react'
import { useT } from '../../i18n'
import { cn } from '../../lib/utils'

export type SitesView = 'list' | 'card'

interface ViewToggleProps {
  view: SitesView
  onChange: (v: SitesView) => void
}

const buttonClass = 'inline-flex h-8 w-8 cursor-pointer items-center justify-center rounded text-fg-subtle hover:text-fg'

export function ViewToggle({ view, onChange }: ViewToggleProps) {
  const t = useT()
  return (
    <div role="group" aria-label={t('sites.view.label')} className="flex items-center rounded-md border border-border bg-surface p-0.5">
      <button
        type="button"
        onClick={() => onChange('list')}
        aria-pressed={view === 'list'}
        aria-label={t('sites.view.list')}
        title={t('sites.view.list')}
        className={cn(buttonClass, view === 'list' && 'bg-accent-soft text-accent-text')}
      >
        <List className="h-4 w-4" />
      </button>
      <button
        type="button"
        onClick={() => onChange('card')}
        aria-pressed={view === 'card'}
        aria-label={t('sites.view.grid')}
        title={t('sites.view.grid')}
        className={cn(buttonClass, view === 'card' && 'bg-accent-soft text-accent-text')}
      >
        <LayoutGrid className="h-4 w-4" />
      </button>
    </div>
  )
}
